async function trackOrder() {
  const orderInput = document.getElementById("orderInput");
  const emailInput = document.getElementById("emailInput");
  const timelineEl = document.getElementById("timeline");
  const statusEl = document.getElementById("deliveryStatus");
  const errorEl = document.getElementById("error");

  // 🔄 Limpa tela
  timelineEl.innerHTML = "";
  statusEl.innerHTML = "";
  errorEl.innerHTML = "";

  const order = orderInput.value.trim();
  const email = emailInput.value.trim();

  if (!order || !email) {
    errorEl.innerText = "Informe o número do pedido e o email.";
    return;
  }

  try {
    const res = await fetch(
      "https://aurea-rastreamento-2026-e98689ec94c8.herokuapp.com/api/rastrear",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          order_number: order,
          email: email,
        }),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      errorEl.innerText = data.message || "Erro ao buscar pedido.";
      return;
    }

    // 🔝 STATUS FIXO NO TOPO
    if (data.deliveryInfo) {
      if (data.deliveryInfo.status === "entregue") {
        statusEl.innerHTML = `
          <div class="status entregue">
            ✅ Pedido entregue em <strong>${data.deliveryInfo.date}</strong>
          </div>
        `;
      } else {
        statusEl.innerHTML = `
          <div class="status transito">
            🚚 Em trânsito — previsão de entrega:
            <strong>${data.deliveryInfo.estimated}</strong>
          </div>
        `;
      }
    }

    // 🧱 TIMELINE
    data.events.forEach((item) => {
      const div = document.createElement("div");
      div.className = "timeline-item";
      div.innerHTML = `
        <div class="dot"></div>
        <div class="content">
          <strong>${item.title}</strong>
          <p>${item.description || ""}</p>
          <span>${item.date}</span>
        </div>
      `;
      timelineEl.appendChild(div);
    });
  } catch (err) {
    console.error(err);
    errorEl.innerText = "Erro ao processar sua solicitação.";
  }
}